import React from 'react'

import { Form, Col } from '_zari/core'

const DocumentoSocioFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='DOC. CLIENTE' htmlFor='input-documentoSocio' md={4} />
      <Col md={8}>
        <Form.InputText value={value} disabled id='input-documentoSocio' />
      </Col>
    </Form.Group>
  )
}

export default DocumentoSocioFormGroup
